(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('stopEvent', function() {
    return {
      link: function(scope, element, attr) {
        return element.bind('click', function(e) {
          return e.stopPropagation();
        });
      }
    };
  });

}).call(this);
